import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";

import Starter from "../../../component/Starter";
import Card from "../../../component/card/Card";
import { monthList, yearList } from "../../../constant/helper/helper";
import SelectInput2 from "../../../component/input/SelectInput2";
import Button from "../../../component/button/Button";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import { hrActions } from "../../../redux/actions";
import { helperFunction } from "../../../constant/helper";
import isEmpty from "../../../validation/isEmpty";
import TableHeader from "../../../component/tableHeader/TableHeader";
import { tableHeaderData } from "./leaveData";
import useSortableData from "../../../customHooks/sortingHooks";
import MyLeaveList from "./MyLeaveList";

const initialState = {
  year: "",
  month: ""
};

const MyLeaves = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.getItem("loginType");

  const [values, setValues] = useState(initialState);
  const [myLeaveList, setMyLeaveList] = useState([]);

  const {
    hrResponse,
    hrError,
    hrLoading,
    myAppliedLeave
  } = useSelector((state) => state.hr);

  useEffect(() => {
    if (hrError) {
      helperFunction.toastHelper("error", hrError);
    }
    if (hrResponse) {
      helperFunction.toastHelper("success", hrResponse);
    }
  }, [hrError, hrResponse]);

  useEffect(() => {
    if (!isEmpty(myAppliedLeave)) {
      setMyLeaveList(myAppliedLeave);
    } else {
      setMyLeaveList([]);
    }
  }, [myAppliedLeave]);

  const showMonthOptions = Object.values(monthList).map(
    (type, index) => (
      <option value={index + 1} key={index}>
        {type}
      </option>
    )
  );
  const showYearOptions = Object.values(yearList).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value
    });
  };

  const onSubmit = () => {
    const data = JSON.stringify(values);
    dispatch(hrActions.setHrLoading(true));
    dispatch(hrActions.clearHrErrors());
    dispatch(hrActions.clearHrResult());
    dispatch(hrActions.myAppliedLeave(data, loginType));
  };

  const { items, requestSort, sortConfig } = useSortableData(
    myLeaveList
  );

  return (
    <Starter
      topBarTitle="Leaves"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">My Leaves</li>
        </Fragment>
      }
    >
      <Card>
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-12">
            <SelectInput2
              data-tip
              name="month"
              isLabeled={true}
              data-for="month"
              label="Select Month"
              value={values.month}
              placeholder="Select Month"
              onChange={handleInputChange}
              icon="mdi mdi-calendar-multiple"
            >
              {showMonthOptions}
            </SelectInput2>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <SelectInput2
              data-tip
              name="year"
              data-for="year"
              isLabeled={true}
              label="Select Year"
              value={values.year}
              placeholder="Select Year"
              onChange={handleInputChange}
              icon="mdi mdi-calendar-question"
            >
              {showYearOptions}
            </SelectInput2>
          </div>
          {hrLoading ? (
            <div className="col-lg-3 col-md-3 col-sm-12">
              <SpinnerButton />
            </div>
          ) : (
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="form-group">
                <Button
                  title="GET"
                  type="button"
                  onClick={onSubmit}
                  isBackgroundColor={false}
                  icon="mdi mdi-plus-circle-outline mr-2"
                  className="btn mb-2 text-white btn-block"
                />
              </div>
            </div>
          )}
        </div>
        <div className="table-responsive">
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <TableHeader
                  tableHeaderData={tableHeaderData}
                  requestSort={requestSort}
                  sortConfig={sortConfig}
                />
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <MyLeaveList
                hrLoading={hrLoading}
                leaveListData={items}
              />
            </tbody>
          </table>
        </div>
      </Card>
    </Starter>
  );
};

export default MyLeaves;
